export default __webpack_public_path__ + "static/media/map.afc4d315.png";